// ScrollContext.js
import React from "react"

const ScrollContext = React.createContext(null)

export default ScrollContext
